export const nomeProva = (prova) => {
    if (prova) {
        let fase = '';
        if (prova.tipo_fase === 'F') {
            fase = 'Final'
        }

        return `${fase} ${prova.sexo === 'F' ? 'Feminino' : 'Masculino'} ${prova.altura.descricao} ${prova.altura.descricao === prova.aparelho.descricao ? '' : prova.aparelho.descricao} ${prova.classe.descricao}`
    } else { return '' }
}